// import * as Sentry from "@sentry/browser";
import parse from "date-fns/parse";
// import mixpanel from "mixpanel-browser";
import { RootStore } from "@/store/root";
import { makeAutoObservable } from "mobx";

export class LoggingStore {
  private _rootStore: RootStore;
  private _firstLaunched: Date | null = null;

  constructor(rootStore: RootStore) {
    this._rootStore = rootStore;

    makeAutoObservable(this);
  }

  public start = async (): Promise<void> => {
    if (!this._rootStore.parameters.has("app.firstLaunched")) {
      this.track("First launch of app");
    }

    if (null === localStorage.getItem("firstLaunched")) {
      this._firstLaunched = new Date();
    } else {
      if (this._rootStore.parameters.has("app.firstLaunched")) {
        this._firstLaunched = this._rootStore.parameters.read<Date>(
          "app.firstLaunched",
          new Date()
        );
      } else {
        //	Read old storage format. Should be removed in future versions.
        this._firstLaunched = parse(
          localStorage.getItem("firstLaunched")!,
          "dd.MM.yyyy HH:mm",
          new Date()
        );
      }
    }

    this.track("First launch of app: " + this._firstLaunched);
    this._rootStore.parameters.writeDateTime(
      "app.firstLaunched",
      this._firstLaunched
    );

    // mixpanel.init(config.mixpanelToken, {
    //   debug: false,
    // });
    // mixpanel.identify(config.deviceUuid);
    // mixpanel.people.set("appVersion", config.version);
    // mixpanel.people.set("OS", TPlatform.Web);
    // mixpanel.people.set("firstLaunched", this._firstLaunched);
  };

  public track = (
    message: string,
    properties?: {
      [key: string]: any;
    }
  ): void => {
    undefined === properties
      ? console.log(message)
      : console.log(message, properties);
    // Sentry.addBreadcrumb({
    //   category: "app",
    //   data: properties,
    //   level: "log",
    //   message,
    //   type: "logging",
    // });
    // mixpanel.track(message, properties);
  };

  public capture = (err: any): any => {
    // Sentry.captureException(err);
    console.error(err);

    return err;
  };
}
